import { createFileRoute } from "@tanstack/react-router";
import { Sidebar } from "@/components/sidebar";
import { VideoFeed } from "@/components/video-feed";
import { MobileNav } from "@/components/mobile-nav";
import { VideosProvider } from "@/hooks/useVideosContext";

export const Route = createFileRoute("/")({ component: App });

function App() {
  return (
    <VideosProvider>
      <div className="flex h-dvh w-screen overflow-hidden  ">
        {/* Desktop Sidebar */}
        <Sidebar />

        {/* Main Content */}
        <main className="flex-1 relative ">
          <VideoFeed />
        </main>

        {/* Mobile Bottom Navigation */}
        <MobileNav />
      </div>
    </VideosProvider>
  );
}
